export default {
  aboutYunDing: '关于云盯',
  backstageLogin: '后台登录',
  softwareDownloads: '软件下载',
  slogan: '云盯 智慧门店管理专家',
  pcPlugin: 'PC插件',
  pcClient: 'PC端',
  enterpriseNum: '企业号',
  loginNum: '账号',
  welcome: '欢迎登录云盯管理系统',
  nextAutoLogin: '下次自动登录',
  loginImmediately: '立即登录',
  accountLogin: '返回账号登录',
  backToLogin: '返回登录',
  yundingOnline: '云盯360',
  $downloadApp: '下载APP',
  $zhangkongStore: '掌控天下门店',
  $copyright: '版权所有©成都汇纳智能科技有限公司',
  loginDownLoadTips1: '使用最新云台功能请下载插件',
  nextAutomaticLogin: '下次自动登录',
  logIn: '立即登录',
  softwareDownload: '软件下载',
  loginPleaseEnter: '请输入',
  password: '密码',
  switchLanguage: '切换语言',
  oldPsd: '原密码',
  newPsd: '新密码',
  repeatNewPsd: '重复新密码',
  inputOldPsd: '请输入原密码',
  inputNewPsd: '请输入新密码',
  inputNewPsdAgain: '请再次输入新密码',
  psdNotLegal: '密码不合法(应为6-16位字符，字符可以为大、小写字母、数字以及~!@#$%^*()_+)',
  newPsdNotLegal: '密码不合法(符号可输入范围为：?!@#$%^*();\'~.,)',
  psdNotLegal2: '密码不合法',
  psdsNotMatch: '两次输入的密码不一致',
  updatePsd: '修改密码',
  Confirm: '确定',
  spacesCannotBeIncluded: '不能包括空格、中文符号，特殊字符仅允许?!@#$%^*();\'~.,',
  theLengthIsSixToSixteenCharacters: '长度为6-16个字符',
  theLengthIsEightToSixteenCharacters: '长度为8-16个字符',
  passwordSecurityLevelMedium: '必须包含大小写字母、数字、特殊符号中至少2种',
  passwordSecurityLevelHigh: '必须包含大小写字母、数字、特殊符号中至少3种',
  passwordSecurityLevelLow: '可使用数字、大小写字母、特殊符号',
  retrieveLoginPassword: '找回登录密码',
  retrievePassword: '找回密码',
  Previous: '上一步',
  pleaseInputYourAccount: '请输入个人账号用于登录',
  pleaseInputThePhoneNumber: '请输入手机号',
  pleaseInputTheEnterpriseNumber: '请输入企业号',
  pleaseInputAnewPassword: '请输入新密码',
  phoneNumber: '手机号',
  Next: '下一步',
  newPassword: '新密码',
  inputAccount: '登录账号',
  Description: '如需修改验证码接收手机号，请联系管理员并至平台[配置管理]-[员工管理]中修改',
  getVerificationCode: '获取验证码',
  enterpriseCode: '企业号',
  Complete: '完成',
  Account: '个人账号',
  forgotPassword: '忘记密码',
  SMSVerificationCode: '短信验证码',
  pleaseInputTheSMSVerificationCode: '请输入短信验证码',
  repeatNewPassword: '重复新密码',
  PleaseRepeatNewPassword: '请重复新密码',
  pleaseInputACorrectPhoneNumber: '请输入正确的手机号',
  Reacquire: '重新获取({number}s)',
  Verification: '验证',
  resetPassword: '重置密码',
  pleaseChangeYourPassword: '首次登录，为保证账号安全，请修改密码',
  thePasswordOfYourAccountHasBeenReset: '您账号的密码已重置，为保证账号安全，请修改密码',
  thePasswordOfYourAccountHasExpired: '你账号的密码已到期，请修改密码',
  theSecurityOfYourAccountPasswordIsTooLow: '为了保证企业账号信息安全，系统对密码的安全等级进行升级，请修改密码',
  thePasswordContainsIllegalCharacters: '密码中含有不合法字符，请按照提示修改密码',
  passwordChanged: '修改成功',
  Back: '返回',
  Welcome: '欢迎登录',
  enterTheOfficialWebsite: '进入官网',
  viewDetails: '查看详情',
  broswers: '360浏览器',
  otherLoginMethods: '其他登录方式',
  qiyeweixin: '企业微信',
  qiyeweixinLogin: '企微登录',
  qiyeweixinInfo: '请输入企业号生成二维码',
  qiyeweixinInput: '请联系系统管理员获取企业号',
  getQRCode: '生成二维码',
  otherQiye: '选择其他企业登录',
  personInfo: '补充个人信息',
  email: '邮箱号',
  placeInputEmail: '请输入邮箱号',
  placeInputACorrectEmail: '请输入正确的邮箱号',
  placeInputPassword: '请输入密码',
  confirmPwd: '确认密码',
  personInfoMsg: '企业微信用户首次扫码登录时，需获取用户个人信息作为账号的基础信息用于后续平台登录使用；信息补充完整后，后续使用企微扫码时将自动免密登录系统',
  noSpace: '首尾禁止使用空格',
  scanDownload: '扫码下载云盯360APP',
  feishu: '飞书',
  feishuLogin: '飞书登录',
  enterpriseBind: '企业绑定',
  feishuBindMsg: '首次使用云盯360需进行企业绑定，绑定成功后将同步飞书通讯录，作为云盯360系统登录账号。绑定成功后方可继续使用云盯360，通过飞书登录云盯系统都将是新账号，账号的操作权限与区域门店权限需要在云盯系统单独授予。',
  inputBindEnterpriseCode: '请输入需要绑定的企业号',
  inputEnterpriseCode: '请输入企业号',
  inputSuperAdminAccountAndPsd: '请输入超管账号及密码',
  inputSuperAdminAccount: '请输入超管账号',
  inputSuperAdminPassword: '请输入超管密码',
  bindQuestion1: '不知道企业号，如何绑定？',
  bindQuestion2: '请联系云盯售后技术人员',
  bindQuestion3: '或者拨打电话至',
  useAccount: '使用账号密码登录',
  placeInputEnterpriseCode: '请输入企业号',
  accountInfo: '账号提示',
  loginAuthInfo: '当前角色或账号没有登录权限，请联系管理员确认并开通权限信息',
  authModalTitle: '提示框',
  authChangeInfo: '权限已被改动,请重新登录',
  psdLength: '长度为{min}-{max}个字符',
  passwordStrengthWeak: '弱',
  passwordStrengthMedium: '中',
  passwordStrengthStrong: '强',
  loginFailed: '登录失败',
  dingtalk: '钉钉',
  weixin: '微信',
  app: 'APP',
  welcomeLogin: '欢迎登录',
  selectLoginMethod: '请选择登录方式访问云盯SaaS平台',
  scanCodeLogin: '扫码登录',
  accountLoginTab: '账号登录',
  thirdPartyLoginTab: '三方登录',
  enterpriseCodeLogin: '企业号登录',
  verifyCodeLogin: '验证码登录',
  accountLabel: '账号',
  pleaseEnterAccount: '请输入账号',
  pleaseEnterPassword: '请输入密码',
  rememberAccount: '记住账号',
  pleaseEnterPhoneNumber: '请输入手机号',
  pleaseEnterCorrectPhoneNumber: '请输入正确的手机号',
  verifyCodeLabel: '验证码',
  pleaseEnterVerifyCode: '请输入验证码',
  pleaseEnterNumDigitCode: '请输入{num}位数字验证码',
  pleaseEnterCorrectVerifyCodeFormat: '请输入正确格式的验证码',
  loginBtn: '登录',
  pleaseEnterEnterpriseCode: '请输入企业号',
  iHaveReadAndAgree: '我已阅读并同意',
  userServiceAgreement: '《用户服务协议》',
  andText: '和',
  privacyPolicyText: '《隐私政策》',
  serviceAgreementTitle: '用户服务协议',
  privacyPolicyTitle: '隐私政策',
  serviceAgreementAndPrivacy: '服务协议及隐私保护',
  disagree: '不同意',
  agree: '同意',
  pleaseReadAgreement: '请仔细阅读并同意',
  continueUse: '后继续使用。',
  bindAccount: '绑定账号',
  pleaseBindEnterpriseAccount: '请绑定您的企业账号',
  confirmBind: '确认绑定',
  inputAccountStep: '输入账号',
  identityVerificationStep: '身份验证',
  resetPasswordStep: '重置密码',
  accountInfoVerify: '账号信息验证',
  pleaseEnterEnterpriseCodeAndAccount: '请输入您的企业号和个人账号',
  securityVerification: '安全验证',
  pleaseCompleteIdentityVerification: '请完成身份验证以继续重置密码',
  setNewPassword: '设置新密码',
  pleaseEnterYourNewPassword: '请输入您的新密码',
  personalAccount: '个人账号',
  pleaseEnterPersonalAccount: '请输入个人账号',
  systemWillAutoFillPhone: '系统将根据您的账号自动带出绑定的手机号用于身份验证',
  systemAutoFilledContact: '系统已自动带出您的联系方式',
  verifyCodeWillBeSentToPhone: '验证码将发送至上述手机号',
  noPhoneBoundWarning: '如果您的账号未绑定手机号，将无法进行下一步操作',
  needModifyPhoneContactAdmin: '如需修改手机号，请联系管理员',
  confirmNewPassword: '确认新密码',
  pleaseEnterNewPasswordAgain: '请再次输入新密码',
  backToLoginPage: '返回登录页',
  backToPreviousStep: '返回上一步',
  pleaseEnterFourDigitCode: '请输入4位数字验证码',
  newPasswordNotMeetRules: '新密码不符合安全规则',
  passwordsNotMatch: '两次输入的密码不一致',
  passwordResetSuccess: '密码重置成功',
  scanSuccess: '扫码成功',
  qrcodeRefreshText: '刷新二维码',
  qrcodeValidity: '二维码有效期：',
  scanCodeLoginSteps: '扫码登录步骤',
  step1OpenApp: '打开云盯APP，进入首页',
  step2ScanQRCode: '点击右上角"扫一扫"按钮，对准二维码扫描',
  step3ConfirmLogin: '在APP上确认登录，即可自动完成网页端登录',
  selectAccount: '选择账号',
  multipleAccountsDetected: '检测到您有多个账号，请选择其中一个登录',
  enterpriseCodeLabel: '企业号：',
  loginAccountLabel: '登录账号：',
  confirmLogin: '确认登录',
  selectThirdPartyLogin: '选择第三方平台账号登录',
  clickIconToAuthorize: '点击下方图标将跳转到对应平台进行授权登录',
  pleaseEnterEnterpriseCodeToGetApp: '请输入企业号获取{name}应用',
  getApp: '获取应用',
  enterpriseNotBind: '企业未绑定',
  enterpriseCancelledBind: '企业取消绑定',
  userNotExist: '用户不存在',
  systemError: '系统错误',
  pleaseEnterVerificationCode: '请输入{maxLength}位验证码',
  retryAfterSeconds: '{remaining}s后重新获取',
  userNotBind: '用户未绑定企业账号，请先绑定企业账号后重试',
  dingtalkUserNotExist: '钉钉用户不存在',
  platformDisabled: '平台已禁用，请联系管理员',
}
